"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const styles_1 = __importDefault(require("../../../../styles/styles"));
const button_1 = __importDefault(require("../../../button/button"));
const eventConstants_1 = require("../../../../constants/eventConstants");
const DefaultProps = {
    text: 'Redial',
    icon: free_solid_svg_icons_1.faPhoneAlt,
};
const CallFailed = ({ redialHandler, callFailedMessage, text, icon }) => (react_1.default.createElement(react_native_1.View, null,
    react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.marginTen, styles_1.default.labelRed] },
        react_1.default.createElement(react_native_paper_1.Title, null, callFailedMessage)),
    react_1.default.createElement(button_1.default, { text: text, icon: icon, onPress: redialHandler, eventName: eventConstants_1.TAP_REDIAL_FAILED_CALL })));
CallFailed.defaultProps = DefaultProps;
exports.default = CallFailed;
